// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","button_premium":"Button_button_premium__Tx+7w"};